import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header" id="home">
      <div className="logo">
        <span className="logo-accent">Stop</span>Spoti
      </div>
      <nav>
        <ul>
          <li><a href="#features">Features</a></li>
          <li><a href="#installation">Setup</a></li>
          <li>
            <a href="https://github.com/Shreeniwas1/stopspoti" target="_blank" rel="noopener noreferrer" className="github-link">
              GitHub
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
